var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState, cloneElement, useCallback, isValidElement, } from 'react';
import { AccordionBase } from './styled';
function Accordion(_a) {
    var { initial = '', children, className, headingsAriaLevel = 3, borderTop = true, borderBottom = true } = _a, props = __rest(_a, ["initial", "children", "className", "headingsAriaLevel", "borderTop", "borderBottom"]);
    const [open, setOpen] = useState(initial);
    const [focus, setFocus] = useState('');
    const ids = useMemo(() => React.Children.toArray(children).reduce((acc, child) => {
        if (isValidElement(child)) {
            return [...acc, child.props.id];
        }
        return acc;
    }, []), [children]);
    const focusIndex = useMemo(() => ids.indexOf(focus), [ids, focus]);
    const previousFocusIndex = focusIndex !== 0 ? focusIndex - 1 : ids.length - 1;
    const nextFocusIndex = focusIndex !== ids.length - 1 ? focusIndex + 1 : 0;
    const handleKeyboard = useCallback((event) => {
        switch (event.key) {
            case 'ArrowUp':
                event.preventDefault();
                setFocus(ids[previousFocusIndex]);
                break;
            case 'ArrowDown':
                event.preventDefault();
                setFocus(ids[nextFocusIndex]);
                break;
            case 'Home':
                event.preventDefault();
                setFocus(ids[0]);
                break;
            case 'End':
                event.preventDefault();
                setFocus(ids[ids.length - 1]);
                break;
            default:
                break;
        }
    }, [ids, nextFocusIndex, previousFocusIndex]);
    return (React.createElement(AccordionBase, Object.assign({ className: `accordion ${borderTop ? '' : 'border-t-0'} ${borderBottom ? '' : 'border-b-0'} ${className}` }, props), React.Children.map(children, (child) => isValidElement(child) &&
        cloneElement(child, Object.assign(Object.assign({ open: open === child.props.id }, child.props), { headingAriaLevel: headingsAriaLevel, headerProps: Object.assign(Object.assign({}, child.props.headerProps), { ref: (instance) => {
                    if (instance &&
                        child.props.id === focus &&
                        ids.includes(document.activeElement.id)) {
                        instance.focus();
                    }
                }, onClick: () => {
                    if (open === child.props.id) {
                        setOpen('');
                        return;
                    }
                    setOpen(child.props.id);
                }, onFocus: () => {
                    setFocus(child.props.id);
                }, onKeyDown: handleKeyboard }) })))));
}
export default Accordion;
